import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import styled from 'styled-components';
import { Box, Flex } from 'atoms';
import { ButtonWrapper } from 'components/ButtonWrapper';
import RCTable from 'components/custom-table/RCTable';
import { BusinessUnitTableConfig } from 'utils/table-config/BusinessUnitTableConfig';
import CreateBusinessUnitModal from './CreateBusinessUnitModal';
import { getListAction } from 'store/pageSlice';

const { Search } = Input;

const LtSearchBar = styled(Search)`
	border: none;
`;

const BlueButtonWrapper = styled(ButtonWrapper)`
background: #18405D;
 !important;
	color: #fff !important;
	&:hover {
		background: #18405D !important;
		color: #fff !important;
	}
`;

export default function BusinessUnitPage() {
	const [rowData, setRowData] = useState({ rows: [], count: 0 });
	const [paginateConfig, setPaginateConfig] = useState({
		search_type: 'business_unit',
		limit: 10,
		offset: 0,
		currentPage: 1,
		filter_by: {},
	});
	const [showCreateModal, setShowCreateModal] = useState(false);
	// eslint-disable-next-line
	const [loading, setLoading] = useState(false);

	const handleCreate = async () => {
		setShowCreateModal(false);
		// Reset to first page after create
		setPaginateConfig((prev) => ({ ...prev, offset: 0, currentPage: 1 }));
		// The useEffect will re-fetch due to paginateConfig change
	};

	return (
		<>
			<Flex justifyContent="space-between" mt={3}>
				<Box flex="0 0 20%" marginRight="10px">
					<LtSearchBar
						placeholder="Search"
						enterButton="Search"
						allowClear
						onSearch={(val) =>
							setPaginateConfig((prev) => {
								const { filter_by, ...rest } = prev;
								return {
									...rest,
									query_str: val,
									offset: 0,
								};
							})
						}
					/>
				</Box>
				<Flex>
					<BlueButtonWrapper
						onClick={() => setShowCreateModal(true)}
						icons={<PlusOutlined />}
					>
						CREATE
					</BlueButtonWrapper>
				</Flex>
			</Flex>
			<Box mt={3}>
				{loading ? (
					<div style={{ textAlign: 'center', marginTop: 40 }}>Loading...</div>
				) : (
					<RCTable
						rowKey="id"
						tableDatas={[rowData, setRowData]}
						togglePaginate={[paginateConfig, setPaginateConfig]}
						dispatchAction={getListAction}
						columns={BusinessUnitTableConfig}
					/>
				)}
			</Box>
			<CreateBusinessUnitModal
				open={showCreateModal}
				onCancel={() => setShowCreateModal(false)}
				onCreate={handleCreate}
			/>
		</>
	);
}
